  <h1 mat-dialog-title style="color: white; background-color: var(--mk3red); text-align: center;">Open Proplab Documents by Mk3
    Reference Number</h1>
  
<form [formGroup]="form" autocomplete="off" novalidate fxLayout="column wrap" fxLayoutAlign="center center"
  fxLayoutGap="10px">

  <mat-dialog-content text-align="middle">
    <small>Mk3 RefNo</small>
    <input type="text" digitOnly inputmode="numeric" formControlName="refNo" class="form-control" maxlength="6"
      (keyup.enter)="onSubmit()" />
    <mat-error *ngIf="hasError('refNo', 'maxlength')">You have entered more than 6 characters!</mat-error>
    <mat-error *ngIf="hasError('refNo', 'pattern')">Invalid RefNo!</mat-error>
  </mat-dialog-content>
</form>

<mat-dialog-actions style="justify-content: center;">
  <button [mat-dialog-close]="refNo" type="button" [disabled]="!form.valid" class="btn btn-danger"
    (click)="onSubmit()" (keyup.enter)="onSubmit()">Open</button>&nbsp;
  <button mat-dialog-close type="button" mat-raised-button class="btn mat-button-base"
    (click)="onCancel()">Cancel</button>
</mat-dialog-actions>

